// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Metrics extends APIResource {
    /**
     * Get step metrics by step ID.
     */
    retrieve(stepID, options) {
        return this._client.get(path `/v1/steps/${stepID}/metrics`, options);
    }
}
//# sourceMappingURL=metrics.mjs.map